/**
 * RecordButton — small icon button that opens the RecordingModal for
 * a given customer. Auto-hides itself when the current user lacks
 * field-tools permission, so callers can drop it in unconditionally.
 */
import { useState } from "react";
import { Microphone } from "@phosphor-icons/react";
import RecordingModal from "@/components/RecordingModal";
import { useFieldTools } from "@/lib/useFieldTools";

export default function RecordButton({ customerId, customerName = "",
                                       variant = "icon", className = "",
                                       testId = "", onSubmitted }) {
  const { allowed } = useFieldTools();
  const [open, setOpen] = useState(false);
  if (!allowed || !customerId) return null;

  const tid = testId || `record-btn-${customerId}`;

  if (variant === "pill") {
    return (
      <>
        <button onClick={(e) => { e.stopPropagation(); setOpen(true); }}
                data-testid={tid}
                title="Record this conversation — we'll transcribe and summarize it for you."
                className={`inline-flex items-center gap-1 px-2 py-1 text-[10px] font-bold uppercase tracking-wider rounded-sm border border-rose-300 text-rose-700 hover:bg-rose-50 ${className}`}>
          <Microphone size={11} weight="fill" /> Record
        </button>
        <RecordingModal open={open} onClose={() => setOpen(false)}
                        customerId={customerId} customerName={customerName}
                        onSubmitted={onSubmitted} />
      </>
    );
  }

  // Default: icon-only (for tight table cells).
  return (
    <>
      <button onClick={(e) => { e.stopPropagation(); setOpen(true); }}
              data-testid={tid}
              title="Record this conversation — we'll transcribe and summarize it for you."
              className={`inline-flex items-center justify-center w-6 h-6 rounded-sm border border-rose-200 text-rose-600 hover:bg-rose-50 ${className}`}>
        <Microphone size={13} weight="fill" />
      </button>
      <RecordingModal open={open} onClose={() => setOpen(false)}
                      customerId={customerId} customerName={customerName}
                      onSubmitted={onSubmitted} />
    </>
  );
}
